import { render, staticRenderFns } from "./ActFiltroPago.vue?vue&type=template&id=2a0bbeab&scoped=true&"
import script from "./ActFiltroPago.vue?vue&type=script&lang=js&"
export * from "./ActFiltroPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0bbeab",
  null
  
)

export default component.exports